export const isBot = (): boolean => {
  if (typeof window === 'undefined') return true;

  const userAgent = navigator.userAgent.toLowerCase();
  const botPatterns = [
    'bot',
    'spider',
    'crawler',
    'slurp',
    'lighthouse',
    'headless',
    'phantom',
    'selenium',
    'puppeteer',
    'chrome-lighthouse',
    'googlebot',
    'yandexbot',
    'bingbot',
    'baiduspider',
    'duckduckbot',
    'semrushbot',
  ];

  return botPatterns.some((pattern) => userAgent.includes(pattern));
};
